import type { PayrollParseResult } from './payrollTypes';
import { extractTextFromPdf } from './parsers/parserUtils';
import { parseJopelPayrollText } from './parsers/jopelParser';

export { extractTextFromPdf };

export async function parsePayrollPdf(file: File): Promise<PayrollParseResult> {
  const pages = await extractTextFromPdf(file);
  // Strategy: Default to Jopel for now.
  // Future: Sniff content to decide provider (e.g. check "Jopel" vs "ADP" headers)
  return parseJopelPayrollText(pages);
}
